// GAVION: why « Appeler » is disabled for a lead (lead header, tasks page). Order matters: Ne pas appeler first, then
// a main number that can't be dialled, then another rep's unexpired lease. null → callable.
type Translate = (key: string, options?: Record<string, unknown>) => string;

export function callDisabledReason(
  lead: {
    is_dnc?: boolean | null;
    phone_e164?: string | null;
    phone_valid?: boolean | null;
  },
  {
    leaseActive,
    holderName,
    checkMainPhone = true,
  }: {
    /** Another rep holds the lead (useLeaseActive). */
    leaseActive: boolean;
    holderName: string | null;
    /** false when the call goes to a contact's own number: the lead's main number then doesn't matter. */
    checkMainPhone?: boolean;
  },
  translate: Translate,
): string | null {
  if (lead.is_dnc) return translate("gavion.dialer.lead.dnc_tooltip");
  if (checkMainPhone && (!lead.phone_e164 || !lead.phone_valid))
    return translate("gavion.dialer.lead.invalid_phone_tooltip");
  if (leaseActive)
    return translate("gavion.dialer.lead.locked_tooltip", {
      name: holderName ?? translate("gavion.dialer.lead.someone"),
    });
  return null;
}
